import DropFiles from '~/components/DropFiles';
import FileItem from '~/components/Items/FileItem';
import Text from '~/components/Text';
import Colors from '~/constants/colors';
import styles from '../StepReview.module.scss';
import UploadMediaItem from '~/components/UploadMediaItem';
import { convertFilesToImages } from '~/utils/converters';
import { uniqBy } from 'lodash';

type StepReviewUploadProps = {
    form?: any;
    discountText?: string;
};

const StepReviewUpload = ({ form, discountText }: StepReviewUploadProps) => {
    const blobToBase64 = (blob: any) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const checkForUpload = async (file: IFile) => {
        let isAllow = false;
        let compressedFile = file;
        let compressedFileBase64 = null;
        if (file) {
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            };
            try {
                isAllow = file.size < 2 * 1024 * 1024;
                compressedFileBase64 = await blobToBase64(file.file);
            } catch (error) {
                console.error(error);
            }
        }

        return {
            isAllow,
            compressedFile,
            url: compressedFileBase64
        };
    };

    const handleChangeUpload = async (files: IFile[]) => {
        const imageFiles = files;

        if (imageFiles.length > 3) {
            // toast.e({ type: 'error', message: 'You can upload maximum 3 image' })
            form.setFieldError('files', 'You can upload maximum 3 image');
            // setLoadingUpload(false)

            return;
        }
        const getLastThreeFile = [];
        // const tempData =  imageFiles;
        for (let i = 0; i < imageFiles.length; i++) {
            getLastThreeFile.push(imageFiles[i]);
        }
        const arrPromise: any = [];
        getLastThreeFile.map((file) => {
            arrPromise.push(
                new Promise((res, rej) => {
                    checkForUpload(file)
                        .then((response) => {
                            if (!response.isAllow) {
                                rej("Image must smaller than 2MB!'");
                            }
                            res({
                                ...file,
                                url: response.url
                            });
                        })
                        .catch((err) => rej(err));
                })
            );
        });
        Promise.all(arrPromise)
            .then((values) => {
                form.setFieldValue('files', values);
            })
            .catch((err) => {
                form.setFieldError('files', err);
            });
    };

    return (
        <div className="flex flex-col justify-center items-center gap-8">
            <div className="">
                <div className="text-2xl font-semibold  text-center">Show it off</div>
                <span className="font-medium text-center">Let everyone see how amazing it truly is.</span>
            </div>

            <div className="border-solid p-4 border border-black">
                {discountText && (
                    <Text type="title-3" color={Colors.GREY_700} className="my-3">
                        {discountText}
                    </Text>
                )}
                {form.values.files?.length ? (
                    <div className="flex flex-wrap gap-x-3 gap-y-2 justify-center items-center">
                        {form.values.files.map((file: any) => (
                            <FileItem
                                file={file}
                                key={file.url}
                                onDelete={() => {
                                    form.setFieldValue(
                                        `files`,
                                        form.values.files?.filter((f: any) => f.url !== file.url)
                                    );
                                    URL.revokeObjectURL(file.url);
                                }}
                            />
                        ))}
                        {form.values.files?.length < 3 && (
                            <UploadMediaItem
                                isMultiple
                                containerSetting={{
                                    width: 72,
                                    height: 72,
                                    borderRadius: 4,
                                    border: '1px dashed',
                                    cursor: 'pointer'
                                }}
                                onFileChange={(files) => {
                                    const newFiles = (form.values.files || []).concat(convertFilesToImages(files));

                                    handleChangeUpload(uniqBy(newFiles, 'url') as any);
                                }}
                            />
                        )}
                    </div>
                ) : (
                    <DropFiles
                        onDrop={
                            handleChangeUpload
                            //   (newFiles) => {

                            //   form.setFieldValue(`files`, newFiles);
                            // }
                        }
                        className={styles.drop_files}
                    />
                )}
                {form.errors.files && <span className={styles.error}>{form.errors.files}</span>}
            </div>
        </div>
    );
};

export default StepReviewUpload;
